import script from "./ProductCenterDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCenterDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ProductCenterDropdown.vue?vue&type=style&index=0&id=3f4a9f77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4a9f77"]])

export default __exports__